import React, { useEffect, useState } from 'react';

import { IDocumentsCell } from '../../../types/IDocumentsCell';

import Icon from '../../../../ui/icon/icon';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';

import './readCell.scss';

const ReadCell: React.FC<IDocumentsCell> = ({ rowType, dataItem, field, treelist, style, className }) => {
  const [isRead, setIsRead] = useState<boolean>(dataItem.isRead);

  if (rowType === 'groupHeader') {
    return null;
  }

  if (dataItem[field] === undefined && treelist) return <td style={style} className={className} />;
  if (dataItem[field] === undefined) return <LoadingCell />;

  useEffect(() => {
    setIsRead(dataItem.isRead);
  }, [isRead]);

  return (
    <td style={style} className={className}>
      <div className='read-cell'>
        <Icon className='read-cell-icon' name={`${isRead && 'fas fa-circle-check'}`} />
      </div>
    </td>
  );
};

export default ReadCell;
